import React, { memo, useRef } from 'react';
import { useUtils as useMuiUtils } from '@material-ui/pickers';
import { ArrowLeft2 as arrowLeftSvg, ArrowRight as arrowRightSvg, } from '@ringcentral/juno-icon';
import { RcVisuallyHidden } from '../../../VisuallyHidden';
import { SelectArrowDownIcon } from '../../Select/styles/SelectArrowDownIcon';
import { StyledCurrentMonth, SwitchHeaderButton, SwitchHeaderButtonWrapper, SwitchHeaderWrapper, } from './styles';
import { useScreenReaderContext } from './utils';
var DatePickerHeader = memo(function (props) {
    var focusedDate = props.focusedDate, onMonthChange = props.onMonthChange, disablePrevMonth = props.disablePrevMonth, disableNextMonth = props.disableNextMonth, onViewChange = props.onViewChange, view = props.view, size = props.size, classes = props.classes;
    var utils = useMuiUtils();
    var preMonth = utils.getPreviousMonth(focusedDate);
    var nextMonth = utils.getNextMonth(focusedDate);
    var monthLabel = utils.getCalendarHeaderText(focusedDate);
    var changeFromRef = useRef();
    var selectNextMonth = function () {
        onMonthChange(nextMonth, 'left');
        changeFromRef.current = 'next';
    };
    var selectPreviousMonth = function () {
        onMonthChange(preMonth, 'right');
        changeFromRef.current = 'previous';
    };
    var ariaExpanded = view === 'year';
    var _a = useScreenReaderContext(), getMonthYearAriaLabel = _a.getMonthYearAriaLabel, getSwitchMonthAriaLabel = _a.getSwitchMonthAriaLabel;
    var monthYearAriaLabel = getMonthYearAriaLabel === null || getMonthYearAriaLabel === void 0 ? void 0 : getMonthYearAriaLabel("" + monthLabel, ariaExpanded);
    var nextMonthAriaLabel = getSwitchMonthAriaLabel === null || getSwitchMonthAriaLabel === void 0 ? void 0 : getSwitchMonthAriaLabel(true, utils.getMonthText(focusedDate));
    var previousMonthAriaLabel = getSwitchMonthAriaLabel === null || getSwitchMonthAriaLabel === void 0 ? void 0 : getSwitchMonthAriaLabel(false, utils.getMonthText(focusedDate));
    return (React.createElement(React.Fragment, null,
        changeFromRef.current && (React.createElement(RcVisuallyHidden, { role: "region", "aria-live": "assertive" }, changeFromRef.current === 'next'
            ? nextMonthAriaLabel
            : previousMonthAriaLabel)),
        React.createElement(SwitchHeaderWrapper, { size: size, className: classes.header },
            React.createElement(StyledCurrentMonth, { role: 'button', tabIndex: 0, "data-focusable": true, view: view, onClick: onViewChange, "aria-label": monthYearAriaLabel, "aria-expanded": ariaExpanded, "data-test-automation-id": "date-picker-month-year", className: classes.select },
                monthLabel,
                React.createElement(SelectArrowDownIcon, null)),
            React.createElement(SwitchHeaderButtonWrapper, { size: size, gap: 3, view: view },
                React.createElement(SwitchHeaderButton, { color: "neutral.f04", size: "small", disabled: disablePrevMonth, onClick: selectPreviousMonth, symbol: arrowLeftSvg, "aria-label": previousMonthAriaLabel, "data-picker-action": true, "data-test-automation-id": "date-picker-pre-month", className: classes.leftArrow, focusVariant: "focusRing" }),
                React.createElement(SwitchHeaderButton, { color: "neutral.f04", size: "small", disabled: disableNextMonth, onClick: selectNextMonth, symbol: arrowRightSvg, "aria-label": nextMonthAriaLabel, "data-picker-action": true, "data-test-automation-id": "date-picker-next-month", className: classes.rightArrow, focusVariant: "focusRing" })))));
});
DatePickerHeader.defaultProps = {
    disablePrevMonth: false,
    disableNextMonth: false,
};
DatePickerHeader.displayName = 'RcDatePickerHeader';
export { DatePickerHeader };
